module.exports = __webpack_public_path__ + "media/images/Grab-0008f6a76953c9205a0606531caf52b8.png";